module.exports = __webpack_public_path__ + "img/needs_unselected.117d0cb6.svg";